/* Hide empty native/BK summaries and empty review sections. Keep positive reviews visible. */
(() => {
  const selector = '.collection-star-section.bk-reviews, #auto-bk-star-section, #auto-bk-review-section';
  function update(element) {
    const text = element.textContent.replace(/\s+/g, ' ').trim();
    const match = element.id === 'auto-bk-review-section'
      ? element.querySelector('.tw-text-xl.bk-text-primary')?.textContent.trim().match(/^([\d.,]+)\s+avaliaç(?:ão|ões)$/i)
      : text.match(/\(\s*([\d.,]+)\s*(?:avaliaç(?:ão|ões)|reviews?)?\s*\)/i);
    const count = match ? Number(match[1].replace(/[.,]/g, '')) : null;
    const state = count > 0 ? 'positive' : count === 0 ? 'empty' : 'pending';
    if (element.dataset.dcReviewCount !== state) element.dataset.dcReviewCount = state;
  }
  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
    const summary = root.closest(selector);
    if (summary) update(summary);
  }
  scan(document.documentElement);
  new MutationObserver((changes) => {
    const roots = new Set();
    for (const change of changes) {
      roots.add(change.target.nodeType === 1 ? change.target : change.target.parentElement);
      change.addedNodes.forEach(node => { if (node.nodeType === 1) roots.add(node); });
    }
    roots.forEach(root => { if (root) scan(root); });
  }).observe(document.body, {childList:true, subtree:true, characterData:true});
})();
